import { notification } from 'antd';

import { setAuthority } from './authority';
import { isJson } from './helpers';

import { API_ROOT } from '../config';
import { logoutUser } from '../redux/auth';
import store from '../store';

const codeMessage = {
  401: 'Пользователь не авторизован',
  403: 'Пользователь авторизован, но доступ запрещен.',
  404: 'Запрос делается для записи, которая не существует',
  500: 'На сервере произошла ошибка.',
};

const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const errortext = codeMessage[response.status] || response.statusText;

  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};

const parseText = (text) => {
  return text && text.length ? (isJson(text) ? JSON.parse(text) : text) : {};
};

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [option] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, option) {
  const options = {
    ...option,
  };

  const defaultOptions = {
    credentials: 'include',
  };
  const newOptions = { ...defaultOptions, ...options };

  if (
    newOptions.method === 'POST' ||
    newOptions.method === 'PATCH' ||
    newOptions.method === 'PUT' ||
    newOptions.method === 'DELETE'
  ) {
    if (!(newOptions.body instanceof FormData) && !(newOptions.body instanceof URLSearchParams)) {
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...newOptions.headers,
      };
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      // newOptions.body is FormData
      newOptions.headers = {
        Accept: 'application/json',
        ...newOptions.headers,
      };
    }
  }

  return fetch(`${API_ROOT}${url}`, newOptions)
    .then(checkStatus)
    .then((response) => {
      return response.text();
    })
    .then((text) => parseText(text))
    .catch(async (e) => {
      const { name: status, response } = e;

      let responseJSON = {};
      let isLoginUrl = false;
      let isAuthEndpoint = false;
      let isLogoutEndpoint = false;
      let requestUrl = '';

      if (response) {
        try {
          requestUrl = response.url || '';
          isLoginUrl = requestUrl.includes('/signin');
          isLogoutEndpoint = requestUrl.includes('/logout');

          const responseText = await response.text();
          responseJSON = parseText(responseText);

          if (responseJSON?.path) {
            isAuthEndpoint =
              responseJSON.path.includes('/login') || responseJSON.path.includes('/auth');
          }
        } catch {
          responseJSON = {};
        }
      }

      const isAuthRequest =
        isLoginUrl ||
        isLogoutEndpoint ||
        isAuthEndpoint ||
        requestUrl.includes('/auth') ||
        requestUrl.includes('/me');

      const error = { status, ...responseJSON };

      if (status === 401 && isAuthRequest) {
        store.dispatch(logoutUser());
      } else if (status === 401) {
        notification.warning({
          message: 'Нет доступа',
          description: 'Недостаточно прав для выполнения операции',
        });
      } else if (status === 403) {
        notification.error({
          message: 'Доступ запрещён',
        });
      }

      return Promise.reject(error);
    });
}
